import { render, staticRenderFns } from "./PopupReservation.vue?vue&type=template&id=67343b22&"
import script from "./PopupReservation.vue?vue&type=script&lang=js&"
export * from "./PopupReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports